import { Environment } from '../models'

const INTERCOM_PROD_APP_ID = 'mdg1akld'
const INTERCOM_TEST_APP_ID = 'e3d4fmq2'

const BRANCH_PROD_KEY = '' // TODO
const BRANCH_TEST_KEY = 'key_test_hzkuS15MCEj1bSBGU7JpdjhbrujSpKUg'

const VGS_PROD_DOMAIN = 'https://vgs.app.cloudtrucks.com'
const VGS_STAGING_DOMAIN = 'https://vgs.app.cloudtrucks-staging.com'
const VGS_DEV_DOMAIN = '/__vgs'
const VGS_DEV_PROXY = '/__vgs'

export const SENTRY_DSN = 'https://02eaf77cf5a640b29c6ff31b6e0ad194@sentry.io/5181431'
export const LOG_ROCKET_APP_ID_WEB = '7zp8gw/cloudtrucks-web'

export const isProduction = process.env.NODE_ENV === 'production'
export const isDevelopment = process.env.NODE_ENV === 'development'
export const isTest = process.env.NODE_ENV === 'test'
export const isIntegrationTest = process.env.REACT_APP_INTEGRATION === 'true'
export const GTM_CONTAINER = 'GTM-KBRTSRN'
export const ONBOARDING_SUPPORT_NUMBER = '(214) 778-1091'

export const privateFieldNames = [
  'password_passthrough',
  'password_encrypted',
  'api_key_encrypted',
  'tax_id_encrypted',
  'tax_form_encrypted',
  'ssn_encrypted',
]

export function detectEnvironment() {
  const originUrl = window.location.origin

  if (process.env.REACT_APP_CLOUDTRUCKS_ENV === 'production') {
    return Environment.PRODUCTION
  }

  if (process.env.REACT_APP_CLOUDTRUCKS_ENV === 'staging') {
    return Environment.STAGING
  }

  if (process.env.REACT_APP_CLOUDTRUCKS_ENV === 'preview') {
    return Environment.PREVIEW
  }

  if (process.env.REACT_APP_CLOUDTRUCKS_ENV === 'development') {
    return Environment.DEVELOPMENT
  }

  // Legacy check
  switch (originUrl) {
    case 'https://app.cloudtrucks.com':
    case 'https://console.cloudtrucks.com':
      return Environment.PRODUCTION
    case 'https://app.cloudtrucks-staging.com':
    case 'https://console.cloudtrucks-staging.com':
      return Environment.STAGING
    case 'https://localhost:3000':
    case 'http://localhost:3000':
    case 'http://localhost:8000':
    case 'http://webapp:8000':
      return Environment.DEVELOPMENT
    default:
      return Environment.UNKNOWN
  }
}

export function getIntercomAppId() {
  if (detectEnvironment() === Environment.PRODUCTION) {
    return INTERCOM_PROD_APP_ID
  }

  return INTERCOM_TEST_APP_ID
}

export function getBranchKey() {
  if (detectEnvironment() === Environment.PRODUCTION) {
    return BRANCH_PROD_KEY
  }

  return BRANCH_TEST_KEY
}

export function getVGSDomain() {
  if (detectEnvironment() === Environment.PRODUCTION) {
    return VGS_PROD_DOMAIN
  }

  // When we are running dev proxy against staging api
  if (process.env.REACT_APP_STAGING_PROXY) {
    return VGS_DEV_PROXY
  }

  if (detectEnvironment() === Environment.STAGING) {
    return VGS_STAGING_DOMAIN
  }

  if (detectEnvironment() === Environment.DEVELOPMENT) {
    return VGS_DEV_DOMAIN
  }

  return VGS_DEV_PROXY
}

export function getDocusignEnv() {
  if (detectEnvironment() === Environment.PRODUCTION) {
    return 'https://na3.docusign.net'
  }

  return 'https://demo.docusign.net'
}

export function getDocusignAccountId() {
  if (detectEnvironment() === Environment.PRODUCTION) {
    return '2a7555f2-b0ea-43e4-9b62-781e9c5f3598'
  }

  return '4edeb575-28e3-45f3-8e92-559605268a05'
}
